const splash = [{
	//啟動圖排程（類別與日曆同頁，不拆 index/form）
	path: "splashes",
	name: "AdminSplash",
	meta: {
		permission: 20001,
		breadcrumb: [{
			key: 'admin.splash.index',
			value: null
		}]
	},
	component: () => import("@/page/content/admin/splash/index.vue"),
}];

export default splash;
